import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { cx } from 'linaria'
import { NavArrowDown } from 'iconoir-react'

const SectionWrapper = styled.div`
   border-bottom: 1px solid var(--color-separator);

   .mobile-filter-section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      padding: 1rem 0;
      background: none;
      border: none;
      text-align: left;
      cursor: pointer;
   }

   .mobile-filter-section-title {
      display: block;
      font-family: var(--font-industry);
      font-weight: 700;
      font-size: 1.1rem;
      color: var(--color-black);
   }

   .mobile-filter-section-summary {
      display: block;
      margin-top: 0.1rem;
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--color-vb-blue);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
   }

   .mobile-filter-section-chevron {
      flex-shrink: 0;
      transition: transform 0.2s ease;
   }

   &.is-open .mobile-filter-section-chevron {
      transform: rotate(180deg);
   }

   .mobile-filter-section-content {
      padding-bottom: 1rem;
   }
`

/**
 * Collapsible filter section in the mobile filter drawer.
 *
 * @param {string} title - Section heading.
 * @param {string} summary - Short description of the current selection, shown below the title.
 */
const MobileFilterSection = ({
   title,
   summary,
   initiallyOpen = false,
   children,
}) => {
   const [isOpen, setIsOpen] = useState(initiallyOpen)

   return (
      <SectionWrapper className={cx(isOpen && 'is-open')}>
         <button
            type="button"
            className="mobile-filter-section-header"
            aria-expanded={isOpen}
            onClick={() => setIsOpen(prev => !prev)}
         >
            <span className="overflow-hidden">
               <span className="mobile-filter-section-title">{title}</span>
               {summary && (
                  <span className="mobile-filter-section-summary">
                     {summary}
                  </span>
               )}
            </span>
            <NavArrowDown
               className="mobile-filter-section-chevron"
               width={22}
               height={22}
               strokeWidth={2}
            />
         </button>
         {isOpen && (
            <div className="mobile-filter-section-content">{children}</div>
         )}
      </SectionWrapper>
   )
}

export default MobileFilterSection
